import * as Styles from './PreScreeningWelcoming.styles';

export default function PreScreeningWelcoming(): JSX.Element {
  return (
    <div>
      <section>
        <Styles.Container isSmaller>
          <Styles.WelcomingText>
            Welcome to our process and thank you for your interest in Trio.
          </Styles.WelcomingText>

          <Styles.WelcomingText>
            As mentioned before, all our clients are from the United States and Canada, so all our
            team members communicate with English native speakers on a daily basis. That’s why the
            first step of our Recruitment Process is a quick English check. For it, we will ask you
            to send us an audio (no more than 4 minutes) spontaneously answering a couple of
            questions.
          </Styles.WelcomingText>
          <Styles.WelcomingText>
            Just for you to deliver your best, we’d like to inform you what we’ll be evaluating 🙂
          </Styles.WelcomingText>

          <Styles.WelcomingText>
            We are looking for candidates who are fluent. This doesn’t mean we’ll take into
            consideration small grammar or pronunciation mistakes, but the fact that you feel
            totally comfortable communicating your experience and achievements, make good use of
            technical and corporate vocabulary and express your ideas efficiently and clearly. This
            will allow you to confidently unfold in different situations once you are part of Trio.
          </Styles.WelcomingText>
          <Styles.WelcomingText>We’re excited to meet you, good luck!</Styles.WelcomingText>

          <Styles.WelcomingText isBold>Trio Talent X Team</Styles.WelcomingText>
        </Styles.Container>
      </section>
    </div>
  );
}
